import React from 'react';
import PropTypes from 'prop-types';
import { productsShape, journeyShape } from 'constants/propTypes';
import { INBOUND, OUTBOUND } from 'constants/booking';
import { Row } from 'components/shared/Layout';
import { splitLegsByDirection } from '../BookingPathReviewBookingSummary.utils';
import SegmentSummaryColumn from './SegmentSummaryColumn';

const SegmentSummary = ({
  currency,
  productFamilies,
  bookingLegs,
  groupName = '',
  isMiceGroupBooking = false,
  infantPassengers = [],
  isLoyaltyBooking = false
}) => {
  const productFamilyName = productFamilies && productFamilies[0].name;
  const [outboundLegs, inboundLegs] = splitLegsByDirection(bookingLegs || []);
  const hasInbound = inboundLegs.length > 0;
  const hasOutbound = outboundLegs.length > 0;
  const sortByDepartureDate = (a, b) => new Date(a.timing.isoDate) - new Date(b.timing.isoDate);
  const sortedInboundLegs = inboundLegs.sort(sortByDepartureDate);
  const sortedOutboundLegs = outboundLegs.sort(sortByDepartureDate);

  return (
    <Row>
      {hasOutbound && (
        <SegmentSummaryColumn
          direction={OUTBOUND}
          productFamilyName={productFamilyName}
          productFamilies={productFamilies}
          currency={currency}
          legs={sortedOutboundLegs}
          groupName={groupName}
          isMiceGroupBooking={isMiceGroupBooking}
          infantPassengers={infantPassengers}
          isLoyaltyBooking={isLoyaltyBooking}
        />
      )}
      {hasInbound && (
        <SegmentSummaryColumn
          direction={INBOUND}
          productFamilyName={productFamilyName}
          productFamilies={productFamilies}
          currency={currency}
          legs={sortedInboundLegs}
          groupName={groupName}
          isMiceGroupBooking={isMiceGroupBooking}
          infantPassengers={infantPassengers}
          isLoyaltyBooking={isLoyaltyBooking}
        />
      )}
    </Row>
  );
};

SegmentSummary.propTypes = {
  currency: PropTypes.string,
  productFamilies: productsShape,
  bookingLegs: journeyShape,
  groupName: PropTypes.string,
  isMiceGroupBooking: PropTypes.bool,
  infantPassengers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      passengerRef: PropTypes.string
    })
  ),
  isLoyaltyBooking: PropTypes.bool
};

export default SegmentSummary;
